var map = {
	"./default/json-plugin": "views/pages/modules/vetting/steps/vet-criteria/additional-details/default/json-plugin",
	"./default/json-plugin.html": "views/pages/modules/vetting/steps/vet-criteria/additional-details/default/json-plugin.html",
	"./default/json-plugin.ts": "views/pages/modules/vetting/steps/vet-criteria/additional-details/default/json-plugin",
	"./ocimf/sire2": "views/pages/modules/vetting/steps/vet-criteria/additional-details/ocimf/sire2",
	"./ocimf/sire2.html": "views/pages/modules/vetting/steps/vet-criteria/additional-details/ocimf/sire2.html",
	"./ocimf/sire2.ts": "views/pages/modules/vetting/steps/vet-criteria/additional-details/ocimf/sire2",
	"./red-marble/base-red-marble": 5313,
	"./red-marble/base-red-marble.ts": 5313,
	"./red-marble/inci": "views/pages/modules/vetting/steps/vet-criteria/additional-details/red-marble/inci",
	"./red-marble/inci.html": "views/pages/modules/vetting/steps/vet-criteria/additional-details/red-marble/inci.html",
	"./red-marble/inci.ts": "views/pages/modules/vetting/steps/vet-criteria/additional-details/red-marble/inci",
	"./red-marble/itf": "views/pages/modules/vetting/steps/vet-criteria/additional-details/red-marble/itf",
	"./red-marble/itf.html": "views/pages/modules/vetting/steps/vet-criteria/additional-details/red-marble/itf.html",
	"./red-marble/itf.ts": "views/pages/modules/vetting/steps/vet-criteria/additional-details/red-marble/itf",
	"./red-marble/mgmt": "views/pages/modules/vetting/steps/vet-criteria/additional-details/red-marble/mgmt",
	"./red-marble/mgmt.html": "views/pages/modules/vetting/steps/vet-criteria/additional-details/red-marble/mgmt.html",
	"./red-marble/mgmt.ts": "views/pages/modules/vetting/steps/vet-criteria/additional-details/red-marble/mgmt",
	"./red-marble/psc": "views/pages/modules/vetting/steps/vet-criteria/additional-details/red-marble/psc",
	"./red-marble/psc.html": "views/pages/modules/vetting/steps/vet-criteria/additional-details/red-marble/psc.html",
	"./red-marble/psc.ts": "views/pages/modules/vetting/steps/vet-criteria/additional-details/red-marble/psc",
	"./rightship/sire": "views/pages/modules/vetting/steps/vet-criteria/additional-details/rightship/sire",
	"./rightship/sire.html": "views/pages/modules/vetting/steps/vet-criteria/additional-details/rightship/sire.html",
	"./rightship/sire.ts": "views/pages/modules/vetting/steps/vet-criteria/additional-details/rightship/sire"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35068;